import { render, staticRenderFns } from "./sequences.vue?vue&type=template&id=86710de8&scoped=true&"
import script from "./sequences.vue?vue&type=script&lang=js&"
export * from "./sequences.vue?vue&type=script&lang=js&"
import style0 from "./sequences.vue?vue&type=style&index=0&id=86710de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86710de8",
  null
  
)

export default component.exports